// CHANGES TO THIS FILE MAY CAUSE INCORRECT BEHAVIOR AND WILL BE LOST IF THE CODE IS REGENERATED
// auto-generated on 4/1/2024 12:07:21 PM by John Caccavaro's (caccavaro123@gmail.com) Frameworks tool.

/* eslint-disable @typescript-eslint/no-empty-interface */

import { ValidationScopeTypeEnum } from '../../../appCore/models/schema/Schema';
import { BankAccountTypeEnum } from '../schema/Schema';
import { PreAuthorizationDebitSignStatusTypeEnum } from '../schema/Schema';
import { BankAccountAuthorizationTypeEnum } from '../schema/Schema';
import { BankAccountStatusTypeEnum } from '../schema/Schema';
import { SignatoryNameVerificationStatusTypeEnum } from '../schema/Schema';
import { MicroDepositStatusTypeEnum } from '../schema/Schema';
import { PlaidVerificationStatusTypeEnum } from '../schema/Schema';
import { BankAccountVerificationTypeEnum } from '../schema/Schema';
import { RiskAssessmentLevelTypeEnum } from '../../../appCore/models/schema/Schema';
import { PermantRiskTypeEnum } from '../../../appCore/models/schema/Schema';
import { WatchlistReasonTypeEnum } from '../../../appCore/models/schema/Schema';
import { DocumentTypeEnum } from '../../../appCore/models/schema/Schema';
import { AgreementTypeEnum } from '../schema/Schema';
import { FormStatusTypeEnum } from '../../../appCore/models/schema/Schema';
import { AdobeEventTypeEnum } from '../../../appCore/models/schema/Schema';
import { DepositStatusTypeEnum } from '../schema/Schema';
import { CountryTypeEnum } from '../../../appCore/models/schema/Schema';

export enum PersistEnum {
  bankNotNull = 0,
  accountTypeRequired = 1,
  bankNotSelected = 2,
  bankInstitutionNumberRequired = 3,
  transitNumberRequired = 4,
  accountNumberRequired = 5,
  accountOwnershipProofRequired = 6,
  authorizedSignatoryRequired = 7,
  signingOfficerSinRequired = 8,
  signingOfficerDobRequired = 9,
  governmentIdProofRequired = 10,
  padRequired = 11,
  invalidSIN = 12,
  duplicateSIN = 13,
  invalidTransitNumber = 14,
  address1Required = 15,
  cityRequired = 16,
  stateRequired = 17,
  postalCodeRequired = 18,
  invalidaBirthYear = 19,
}

export enum GetBankListEnum {
  companyIdLessThan1 = 0,
  skipLessThan0 = 1,
  takeGreaterThan100 = 2,
}

export enum GetBankAuthorizationAgreementEnum {
  companyIdIsRequired = 0,
  companyBankAccountIdIsRequired = 1,
  incorrectAgreementType = 2,
}

export enum GetBankAccountInitialStateRequestEnum {
  invalidCompanyId = 0,
  accountNotVerified = 1,
}

export enum PersistBankAuthorizationAgreementEnum {
  companyIdIsRequired = 0,
  companyBankAccountIdIsRequired = 1,
  signatoryIdIsRequired = 2,
  signatoryIsRequired = 3,
}

export enum PersistBankAccountVerificationEnum {
  companyIdIsRequired = 0,
  companyBankAccountIdIsRequired = 1,
  invalidCompanyId = 2,
  invalidBankAccountStatus = 3,
}

export enum PersistBankAccountDocumentEnum {
  companyIdIsRequired = 0,
  companyBankAccountIdIsRequired = 1,
  documentIdRequired = 2,
  documentNameIsRequired = 3,
}

export enum GetBankAccountVerificationEnum {
  companyIdIsRequired = 0,
  bankAccountIdRequired = 1,
}

export enum VerifyMicroDepositAmountEnum {
  companyIdIsRequired = 0,
  bankAccountIdIsRequired = 1,
  amountIsZero = 2,
}

export enum DeleteBankAccountDocumentEnum {}

export enum GetLockedMicroDepositListEnum {}

export enum UnlockMicroDepositEnum {
  companyIdIsRequired = 0,
  companyBankAccountIdIsRequired = 1,
}

export enum AgreementDocumentTypeEnum {
  preAuthDebit = 0,
  accountValidationRequest = 1,
}

export enum GetLockedMicroDeposit {
  companyIdIsRequired = 0,
}

export enum SubmitAdditionalRiskDocumentEnum {
  companyIdIsRequired = 0,
  companyBankAccountIdIsRequired = 1,
}

export enum SendMicroDepositAmountEnum {
  companyIdIsRequired = 0,
  companyBankAccountIdIsRequired = 1,
}

export enum BankAccountPurposeTypeEnum {
  company = 0,
  partner = 1,
  companyAndPartner = 2,
}

export enum ValidateBankBranchEnum {
  institutionNumberIsRequired = 0,
  invalidInstitutionNumberLength = 1,
  transitNumberIsRequired = 2,
  invalidTransitNumberLength = 3,
  invalidTransitNumber = 4,
}

export enum PersistBankAccountEnum {
  accountTypeRequired = 0,
  bankNotSelected = 1,
  bankInstitutionNumberRequired = 2,
  transitNumberRequired = 3,
  accountNumberRequired = 4,
  accountOwnershipProofRequired = 5,
  invalidTransitNumber = 6,
}

export enum PersistAuthorizedSignatoryEnum {
  authorizedSignatoryRequired = 0,
  signingOfficerSinRequired = 1,
  signingOfficerDobRequired = 2,
  invalidSIN = 3,
  duplicateSIN = 4,
  governmentIdProofRequired = 5,
  padRequired = 6,
  invalidBirthYear = 7,
}

export enum GetAuthorizedSignatoryEnum {
  companyIdIsRequired = 0,
  companyBankAccountIdIsRequired = 1,
}

export enum GetBankAccountEnum {
  companyIdIsRequired = 0,
}

export enum PersistBankAccountAndSignatoryEnum {
  bankNotSelected = 0,
  transitNumberRequired = 1,
  accountNumberRequired = 2,
  signatoryRequired = 3,
}

export enum DeletePreAuthorizationDebitAgreementEnum {
  companyIdIsRequired = 0,
  bankAccountIdIsRequired = 1,
}

export enum GetBankAccountDocumentEnum {
  companyIdIsRequired = 0,
  companyBankAccountIdIsRequired = 1,
}

export interface PersistRequestInterface {
  persistBankAgreementKey: boolean;
  persistBankDocument: string;
  validationScopeType: ValidationScopeTypeEnum;
  editOnlyBankingInformation: boolean;
  hasResignedDocument: boolean;
  editOnlyBankAccountPurposeType: boolean;
  editOnlyAuthorizedSignatoryInformation: boolean;
  bankAccount: BankAccountInterface;
}

export interface PersistResponseInterface {
  id: number;
  validationResults: ValidationResultsInterface;
}

export interface GetSigningAuthorityListRequestInterface {
  companyId: number;
}

export interface GetSigningAuthorityListResponseInterface {
  signingAuthorityList: Array<SigningAuthorityInterface>;
  validationResults: ValidationResultsInterface;
}

export interface BankAccountInterface {
  id: number;
  companyId: number;
  accountType: BankAccountTypeEnum;
  accountNumber: string;
  transitNumber: string;
  name: string;
  confirmedBusinessAccount: boolean;
  lastSavedDate: string;
  isMicroDepositRejected: boolean;
  preAuthorizationDebitSignStatusType: PreAuthorizationDebitSignStatusTypeEnum;
  bankAccountAuthorizationStatus: BankAccountAuthorizationTypeEnum;
  bankAccountStatus: BankAccountStatusTypeEnum;
  institutionNumber: string;
  bankAccountPurposeType: BankAccountPurposeTypeEnum;
  documentList: Array<DocumentInterface>;
  signingAuthority: SigningAuthorityInterface | null; // todo: can be nullable
  signingAuthorityId: number;
  bank?: BankInterface;
  bankId?: number | null; // todo: can be nullable
  bankAuthorizationAgreementList: Array<BankAuthorizationAgreementInterface>;
}

export interface SigningAuthorityInterface {
  id: number;
  name: string;
  sin: string;
  dateOfBirth?: string;
  isCurrentLoggedInUser: boolean;
  signatoryNameVerificationStatusType?: SignatoryNameVerificationStatusTypeEnum;
  address?: AddressInterface; // todo: address should be required after SigningOfficerHomeAddress feature flag removing
  email?: string;
}

export interface VerifyMicroDepositAmountRequestInterface {
  companyId: number;
  bankAccountId: number;
  amount: number;
}

export interface VerifyMicroDepositAmountResponseInterface {
  verificationAttemptCount: number;
  status: MicroDepositStatusTypeEnum;
  validationResults: ValidationResultsInterface;
}

export interface GetBankListRequestInterface {
  name: string;
  getByName: boolean;
  companyId: number;
  skip: number;
  take: number;
  getOnlyDefaultCompanyBankList: boolean;
  getBySearchTerm: boolean;
  searchTerm: string;
}

export interface GetBankListResponseInterface {
  bankList: Array<BankInterface>;
  validationResults: ValidationResultsInterface;
}

export interface BankInterface {
  id: number;
  name: string;
  companyId: number;
  institutionNumber: string;
  acronym?: string;
}

export interface BankAccountVerificationInterface {
  companyId: number;
  bankAccountId: number;
  accountNumber: string;
  processingTimeLine: number;
  microDepositStatus: MicroDepositStatusTypeEnum;
  plaidVerificationStatus: PlaidVerificationStatusTypeEnum;
  confirmedPreAuthDebit: boolean;
  isAdditionalInfoRequired: boolean;
  bankAccountVerificationType: BankAccountVerificationTypeEnum;
  bankAccountAuthorizationStatus: BankAccountAuthorizationTypeEnum;
  bankAccountStatus: BankAccountStatusTypeEnum;
  requestAdditionalDocuments: boolean;
  microDepositAmountAlreadySent: boolean;
  businessIncorporationnumber: string;
  jurisdictionId?: number;
  riskAssessmentLevelType: RiskAssessmentLevelTypeEnum;
  permantRiskType: PermantRiskTypeEnum;
  watchlistReasonType: WatchlistReasonTypeEnum;
  reviewCommentsList: Array<ReviewCommentsInterface>;
  bankAuthorizationAgreementList: Array<BankAuthorizationAgreementInterface>;
  documentList: Array<DocumentInterface>;
}

export interface DocumentInterface {
  id: number;
  documentId: number;
  documentName: string;
  documentType: DocumentTypeEnum;
  uploadedOn: string;
}

export interface PersistBankAccountVerificationRequestInterface {
  companyId: number;
  companyBankAccountId: number;
  isSubmit: boolean;
  bankAccountVerificationType: BankAccountVerificationTypeEnum;
  businessIncorporationnumber: string;
  jurisdictionId?: number;
  bankAuthorizationAgreement?: BankAuthorizationAgreementInterface; // todo: should be optional for now
}

export interface PersistBankAccountVerificationResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetBankAccountVerificationRequestInterface {
  companyId: number;
  bankAccountId: number;
}

export interface GetBankAccountVerificationResponseInterface {
  verificationAttemptCount: number;
  hideAccountSignatureWarningFlag: boolean;
  bankAccountVerification: BankAccountVerificationInterface;
  validationResults: ValidationResultsInterface;
}

export interface GetBankAuthorizationAgreementRequestInterface {
  companyId: number;
  companyBankAccountId?: number;
  agreementType: AgreementTypeEnum;
  rowKey: string;
}

export interface GetBankAuthorizationAgreementResponseInterface {
  documentId: number;
  agreementFile: Array<number>;
  echoSignAgreementId: string;
  echoSignAgreementSigningUrl: string;
  isEsigned: boolean;
  agreementStatusType: FormStatusTypeEnum;
  signedDate?: string;
  agreementFileMimeType: string;
  validationResults: ValidationResultsInterface;
}

export interface GetBankAccountInitialStateRequestInterface {
  companyId: number;
  bankAccountPurposeType: BankAccountPurposeTypeEnum;
}

export interface GetBankAccountInitialStateResponseInterface {
  isAdditionalInfoRequired: boolean;
  showFraudAlert: boolean;
  companiesWithTheSameBlacklistData: Array<string>;
  bankAccount: BankAccountInterface;
  validationResults: ValidationResultsInterface;
}

export interface PersistBankAuthorizationAgreementRequestInterface {
  companyId: number;
  companyBankAccountId: number;
  signatoryId: number;
  signatory: string;
  agreementType: AgreementDocumentTypeEnum;
}

export interface PersistBankAuthorizationAgreementResponseInterface {
  bankAuthorizationAgreementList: Array<BankAuthorizationAgreementInterface>;
  validationResults: ValidationResultsInterface;
}

export interface ReviewCommentsInterface {
  id: number;
  text: string;
}

export interface BankAuthorizationAgreementInterface {
  documentId: number;
  documentName: string;
  agreementType: AgreementTypeEnum;
  agreementStatus: FormStatusTypeEnum;
  agreementId: string;
  agreementUrl: string;
  signedDate?: string;
  rowKey: string;
  isManuallySigned: boolean;
}

export interface PersistBankAccountDocumentRequestInterface {
  companyId: number;
  companyBankAccountId: number;
  documentType: DocumentTypeEnum;
  documentId: number;
  documentName: string;
  agreementType: AgreementTypeEnum;
}

export interface PersistBankAccountDocumentResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface DeleteBankAccountDocumentRequestInterface {
  companyBankAccountId: number;
  documentId: number;
}

export interface DeleteBankAccountDocumentResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface ProcessAdobeCallbackRequestInterface {
  echoSignPartitionKey: string;
  echoSignRowKey: string;
  adobeEventType: AdobeEventTypeEnum;
}

export interface ProcessAdobeCallbackResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface UploadBankAuthorizationAgreementRequestInterface {
  companyId: number;
  companyBankAccountId: number;
  agreementType: AgreementTypeEnum;
  documentId: number;
}

export interface UploadBankAuthorizationAgreementResponseInterface {
  documentId: number;
  validationResults: ValidationResultsInterface;
}

export interface GetLockedMicroDepositListRequestInterface {
  sortByDescending: boolean;
}

export interface GetLockedMicroDepositListResponseInterface {
  lockedMicroDepositList: Array<LockedMicroDepositInterface>;
  validationResults: ValidationResultsInterface;
}

export interface LockedMicroDepositInterface {
  companyId: number;
  companyName: string;
  bankAccountId: number;
  depositStatusType: DepositStatusTypeEnum;
  depositAmount: number;
  depositDate?: string;
  verificationDate?: string;
  verificationAmount: number;
  bankAccountPurposeType: BankAccountPurposeTypeEnum;
  rejectionActivity?: RejectionActivityInterface;
}

export interface VerifyDummyPlaidRequestInterface {
  companyId: number;
  companyBankAccountId: number;
}

export interface VerifyDummyPlaidResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface UnlockMicroDepositRequestInterface {
  companyId: number;
  companyBankAccountId: number;
}

export interface UnlockMicroDepositResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetLockedMicroDepositRequestInterface {
  companyId: number;
}

export interface GetLockedMicroDepositResponseInterface {
  lockedMicroDeposit: LockedMicroDepositInterface;
  validationResults: ValidationResultsInterface;
}

export interface RejectionActivityInterface {
  id: number;
  rejectionReason: string;
  rejectionDate: string;
  lockedMicroDeposit: LockedMicroDepositInterface;
}

export interface CreateBankAccountAgreementRequestInterface {
  companyId: number;
  signatoryId: number;
  accountNumber: string;
  bankName: string;
  transitNumber: string;
  agreementType: AgreementDocumentTypeEnum;
  institutionNumber?: string; // todo: should be optional for now
}

export interface CreateBankAccountAgreementResponseInterface {
  bankAuthorizationAgreementList: Array<BankAuthorizationAgreementInterface>;
  validationResults: ValidationResultsInterface;
}

export interface SubmitAdditionalRiskDocumentRequestInterface {
  companyId: number;
  companyBankAccountId: number;
  documentList: Array<DocumentInterface>;
}

export interface SubmitAdditionalRiskDocumentResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface SendMicroDepositAmountRequestInterface {
  companyId: number;
  companyBankAccountId: number;
}

export interface SendMicroDepositAmountResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface AddressInterface {
  address1: string;
  address2: string;
  city: string;
  stateId?: number;
  postal: string;
  country: string;
  countryType: CountryTypeEnum;
}

export interface ValidateBankBranchRequestInterface {
  institutionNumber: string;
  transitNumber: string;
}

export interface ValidateBankBranchResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface PersistBankAccountRequestInterface {
  validationScopeType: ValidationScopeTypeEnum;
  bankAccount: BankAccountInterface;
}

export interface PersistBankAccountResponseInterface {
  id: number;
  validationResults: ValidationResultsInterface;
}

export interface PersistAuthorizedSignatoryRequestInterface {
  companyId: number;
  validationScopeType: ValidationScopeTypeEnum;
  bankAccountId: number;
  hasResignedDocument: boolean;
  signingAuthority: SigningAuthorityInterface;
  documentList: Array<DocumentInterface>;
  bankAuthorizationAgreementList: Array<BankAuthorizationAgreementInterface>;
}

export interface PersistAuthorizedSignatoryResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetAuthorizedSignatoryRequestInterface {
  companyId: number;
  companyBankAccountId: number;
}

export interface GetAuthorizedSignatoryResponseInterface {
  preAuthorizationDebitSignStatusType: PreAuthorizationDebitSignStatusTypeEnum;
  signingAuthority: SigningAuthorityInterface;
  documentList: Array<DocumentInterface>;
  bankAuthorizationAgreementList: Array<BankAuthorizationAgreementInterface>;
  validationResults: ValidationResultsInterface;
}

export interface GetBankAccountRequestInterface {
  companyId: number;
  bankAccountPurposeType: BankAccountPurposeTypeEnum;
}

export interface GetBankAccountResponseInterface {
  isAdditionalInfoRequired: boolean;
  showFraudAlert: boolean;
  companiesWithTheSameBlacklistData: Array<string>;
  bankAccount: BankAccountInterface;
  validationResults: ValidationResultsInterface;
}

export interface PersistBankAccountAndSignatoryRequestInterface {
  bankAccount: BankAccountInterface;
  microDeposit: MicroDepositInterface;
}

export interface PersistBankAccountAndSignatoryResponseInterface {
  id: number;
  validationResults: ValidationResultsInterface;
}

export interface MicroDepositInterface {
  verificationDepositAmount: number;
  microDepositVerificationAmount?: number;
  microDepositStatus: MicroDepositStatusTypeEnum;
  verificationDate: string;
}

export interface PersistPreAuthorizationDebitAgreementRequestInterface {
  companyId: number;
  bankAuthorizationAgreement: PersistBankAuthorizationAgreementInterface; // todo: added by Nitesh for migration
}

// todo: type added by Nitesh for migration
export interface PersistBankAuthorizationAgreementInterface {
  documentId: number;
  agreementType: number;
  isManuallySigned: boolean;
  signedDate: string;
  rowKey: string;
}

export interface PersistPreAuthorizationDebitAgreementResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface DeletePreAuthorizationDebitAgreementRequestInterface {
  companyId: number;
  bankAccountId: number;
}

export interface DeletePreAuthorizationDebitAgreementResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetBankAccountDocumentRequestInterface {
  companyId: number;
  companyBankAccountId: number;
  documentType: DocumentTypeEnum;
}

export interface GetBankAccountDocumentResponseInterface {
  documentId: number;
  documentMimeType: string;
  documentContent: Array<number>;
  validationResults: ValidationResultsInterface;
}

export enum ValidationSeverityEnum {
  NotDefined = 0,
  Passed,
  Information,
  Warning,
  Error,
}

export interface ValidationResultInterface {
  validationSeverityEnum: ValidationSeverityEnum;
  validationMessage: string;
  exceptionInformation: string;
  validationCode: number;
  validationTag: string;
  isValid: boolean;
}

export interface ValidationResultsInterface {
  validationResultList?: Array<ValidationResultInterface>;
}

import { Post } from '../../../httpClient';

export class CompanyBankAccessService {
  persist(request: PersistRequestInterface): Promise<PersistResponseInterface> {
    return Post('/FinanceCompanyBankAccess/persist', request);
  }

  getSigningAuthorityList(
    request: GetSigningAuthorityListRequestInterface
  ): Promise<GetSigningAuthorityListResponseInterface> {
    return Post('/FinanceCompanyBankAccess/getSigningAuthorityList', request);
  }

  verifyMicroDepositAmount(
    request: VerifyMicroDepositAmountRequestInterface
  ): Promise<VerifyMicroDepositAmountResponseInterface> {
    return Post('/FinanceCompanyBankAccess/verifyMicroDepositAmount', request);
  }

  getBankList(request: GetBankListRequestInterface): Promise<GetBankListResponseInterface> {
    return Post('/FinanceCompanyBankAccess/getBankList', request);
  }

  persistBankAccountVerification(
    request: PersistBankAccountVerificationRequestInterface
  ): Promise<PersistBankAccountVerificationResponseInterface> {
    return Post('/FinanceCompanyBankAccess/persistBankAccountVerification', request);
  }

  getBankAccountVerification(
    request: GetBankAccountVerificationRequestInterface
  ): Promise<GetBankAccountVerificationResponseInterface> {
    return Post('/FinanceCompanyBankAccess/getBankAccountVerification', request);
  }

  getBankAuthorizationAgreement(
    request: GetBankAuthorizationAgreementRequestInterface
  ): Promise<GetBankAuthorizationAgreementResponseInterface> {
    return Post('/FinanceCompanyBankAccess/getBankAuthorizationAgreement', request);
  }

  getBankAccountInitialState(
    request: GetBankAccountInitialStateRequestInterface
  ): Promise<GetBankAccountInitialStateResponseInterface> {
    return Post('/FinanceCompanyBankAccess/getBankAccountInitialState', request);
  }

  persistBankAuthorizationAgreement(
    request: PersistBankAuthorizationAgreementRequestInterface
  ): Promise<PersistBankAuthorizationAgreementResponseInterface> {
    return Post('/FinanceCompanyBankAccess/persistBankAuthorizationAgreement', request);
  }

  persistBankAccountDocument(
    request: PersistBankAccountDocumentRequestInterface
  ): Promise<PersistBankAccountDocumentResponseInterface> {
    return Post('/FinanceCompanyBankAccess/persistBankAccountDocument', request);
  }

  deleteBankAccountDocument(
    request: DeleteBankAccountDocumentRequestInterface
  ): Promise<DeleteBankAccountDocumentResponseInterface> {
    return Post('/FinanceCompanyBankAccess/deleteBankAccountDocument', request);
  }

  processAdobeCallback(request: ProcessAdobeCallbackRequestInterface): Promise<ProcessAdobeCallbackResponseInterface> {
    return Post('/FinanceCompanyBankAccess/processAdobeCallback', request);
  }

  uploadBankAuthorizationAgreement(
    request: UploadBankAuthorizationAgreementRequestInterface
  ): Promise<UploadBankAuthorizationAgreementResponseInterface> {
    return Post('/FinanceCompanyBankAccess/uploadBankAuthorizationAgreement', request);
  }

  getLockedMicroDepositList(
    request: GetLockedMicroDepositListRequestInterface
  ): Promise<GetLockedMicroDepositListResponseInterface> {
    return Post('/FinanceCompanyBankAccess/getLockedMicroDepositList', request);
  }

  verifyDummyPlaid(request: VerifyDummyPlaidRequestInterface): Promise<VerifyDummyPlaidResponseInterface> {
    return Post('/FinanceCompanyBankAccess/verifyDummyPlaid', request);
  }

  unlockMicroDeposit(request: UnlockMicroDepositRequestInterface): Promise<UnlockMicroDepositResponseInterface> {
    return Post('/FinanceCompanyBankAccess/unlockMicroDeposit', request);
  }

  getLockedMicroDeposit(
    request: GetLockedMicroDepositRequestInterface
  ): Promise<GetLockedMicroDepositResponseInterface> {
    return Post('/FinanceCompanyBankAccess/getLockedMicroDeposit', request);
  }

  createBankAccountAgreement(
    request: CreateBankAccountAgreementRequestInterface
  ): Promise<CreateBankAccountAgreementResponseInterface> {
    return Post('/FinanceCompanyBankAccess/createBankAccountAgreement', request);
  }

  submitAdditionalRiskDocument(
    request: SubmitAdditionalRiskDocumentRequestInterface
  ): Promise<SubmitAdditionalRiskDocumentResponseInterface> {
    return Post('/FinanceCompanyBankAccess/submitAdditionalRiskDocument', request);
  }

  sendMicroDepositAmount(
    request: SendMicroDepositAmountRequestInterface
  ): Promise<SendMicroDepositAmountResponseInterface> {
    return Post('/FinanceCompanyBankAccess/sendMicroDepositAmount', request);
  }

  validateBankBranch(request: ValidateBankBranchRequestInterface): Promise<ValidateBankBranchResponseInterface> {
    return Post('/FinanceCompanyBankAccess/validateBankBranch', request);
  }

  persistBankAccount(request: PersistBankAccountRequestInterface): Promise<PersistBankAccountResponseInterface> {
    return Post('/FinanceCompanyBankAccess/persistBankAccount', request);
  }

  persistAuthorizedSignatory(
    request: PersistAuthorizedSignatoryRequestInterface
  ): Promise<PersistAuthorizedSignatoryResponseInterface> {
    return Post('/FinanceCompanyBankAccess/persistAuthorizedSignatory', request);
  }

  getAuthorizedSignatory(
    request: GetAuthorizedSignatoryRequestInterface
  ): Promise<GetAuthorizedSignatoryResponseInterface> {
    return Post('/FinanceCompanyBankAccess/getAuthorizedSignatory', request);
  }

  getBankAccount(request: GetBankAccountRequestInterface): Promise<GetBankAccountResponseInterface> {
    return Post('/FinanceCompanyBankAccess/getBankAccount', request);
  }

  persistBankAccountAndSignatory(
    request: PersistBankAccountAndSignatoryRequestInterface
  ): Promise<PersistBankAccountAndSignatoryResponseInterface> {
    return Post('/FinanceCompanyBankAccess/persistBankAccountAndSignatory', request);
  }

  persistPreAuthorizationDebitAgreement(
    request: PersistPreAuthorizationDebitAgreementRequestInterface
  ): Promise<PersistPreAuthorizationDebitAgreementResponseInterface> {
    return Post('/FinanceCompanyBankAccess/persistPreAuthorizationDebitAgreement', request);
  }

  deletePreAuthorizationDebitAgreement(
    request: DeletePreAuthorizationDebitAgreementRequestInterface
  ): Promise<DeletePreAuthorizationDebitAgreementResponseInterface> {
    return Post('/FinanceCompanyBankAccess/deletePreAuthorizationDebitAgreement', request);
  }

  getBankAccountDocument(
    request: GetBankAccountDocumentRequestInterface
  ): Promise<GetBankAccountDocumentResponseInterface> {
    return Post('/FinanceCompanyBankAccess/getBankAccountDocument', request);
  }
}

export default new CompanyBankAccessService();
